import { Monitor, getStatusClass, getStatusText } from '../types/status';

interface MonitorItemProps {
  monitor: Monitor;
}

const MonitorItem = ({ monitor }: MonitorItemProps) => {
  const statusClass = getStatusClass(monitor.status);
  const statusText = getStatusText(monitor.status);

  return (
    <li>
      <span className="monitor-name">{monitor.friendlyName}</span>
      <div className="monitor-status-wrapper">
        <span className={`monitor-status ${statusClass}`}>{statusText}</span>
      </div>
    </li>
  );
};

export default MonitorItem;
